<div class="container-main" *ngIf="isAutenticado()">
  <div  class="d-flex flex-column bd-highlight mb-0" [ngClass]="theme">
    <app-header (openMenu)="showEvent($event)"></app-header>
  </div>
  <div class="flex-row container-stage" [ngClass]="theme">
    <div class="m-0 sidemenu" [ngClass]="theme">
      <app-sidemenu [showMenu]="openMenuOne"></app-sidemenu>
    </div>
    <div class="d-flex flex-column bd-highlight stage">
      <div class="inside-stage">
        <router-outlet></router-outlet>
        <app-footer class="" [ngClass]="theme"></app-footer>
      </div>
    </div>
  </div>
</div>
